const seniorityLevels = [
  {
    id: "EXPERIENCED",
    name: 'Experienced (2+ years required)',
    color: '#dbb3f4',
    tag: 'EXPERIENCED',
  },
  {
    id: "JUNIOR",
    name: 'Junior or switchers (0-1 years of exp., not new grad)',
    color: '#b3f4b3',
    tag: 'JUNIOR',
  }, 
  {
    id: "NEW_GRAD",
    name: 'New grads',
    color: 'b5dbff',
    tag: 'NEW GRADS',
  },  
  {
    id: "UNSPECIFIED",
    name: 'No experience level specified',
    color: '#fff3b5',
    tag: 'UNSPECIFIED LEVEL',
  },
]

export default seniorityLevels
